// get the set of month names for the actiuve language
import { useActiveLangStrings } from "./use-active-lang-strings";
export var useMonthNamesShort = function () {
  var strings = useActiveLangStrings();
  var monthNamesShort = strings.monthNamesShort || 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec';
  return monthNamesShort.split('_');
};